import {RemoteGetBeneficiaryAddressSuggestionV4} from 'data/usecases';
import {GetBeneficiaryAddressSuggestionV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetBeneficiaryAddressSuggestionV4 = (): GetBeneficiaryAddressSuggestionV4 =>
	new RemoteGetBeneficiaryAddressSuggestionV4(
		makeBFFApiUrl(ProfileChangeDataEndpoints.beneficiaryAddressSuggestionV4),
		makeAuthorizeHttpClientDecorator(),
	);
